module.exports = __webpack_public_path__ + "img/cosmetics_info.fb7ac327.png";